<div *ngIf="debugMode"
    style="position: fixed; top: 156px; right: 50px; background: rgb(161, 191, 255); width: 350px; height: 350px; border: 3px solid black; z-index: 9999999; padding: 10px;">
    <i class="pi pi-cog" style="font-size: 23px" [ngClass]="{'pi-spin' : idleTimer}"></i>
    <div style="margin-top: -3px;">RUN</div>
    <div style="text-align: center; text-decoration: underline;">
        <strong>DEBUG</strong><br>
        <strong><button (click)="stop()">STOP</button></strong>
    </div>
    <br>
    timeoutWarningPhase : {{timeoutWarningPhase | json}} <br>
    idleTimeoutDelayRemainingSec : {{idleTimeoutDelayRemainingSec | json}} <br>
    extendSessionWindowRmainingSec : {{extendSessionWindowRmainingSec | json}} <br>
    DEFAULT_IDLE_TIMEOUT_DELAY_SEC : {{DEFAULT_IDLE_TIMEOUT_DELAY_SEC | json}} <br>
    AFTER_EXTENSION_IDLE_TIMEOUT_DELAY_SEC : {{AFTER_EXTENSION_IDLE_TIMEOUT_DELAY_SEC | json}} <br>
    EXTEND_SESSION_WINDOW_OPEN_DELAY_SEC : {{EXTEND_SESSION_WINDOW_OPEN_DELAY_SEC | json}} <br>
</div>

<p-toast position="top-center" key="sessionWarning" [breakpoints]="{'350px': {width: '100%'}}" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div class="flex flex-column" style="flex: 1">
            <div class="text-center">
                <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
                <h4 class="text-yellow-900">{{'sessionNotification.closeSession' | translate}}</h4>
                <p>{{'sessionNotification.msj1' | translate}} <strong>{{extendSessionWindowRmainingSec}}</strong>
                    {{'sessionNotification.second' | translate}}.</p>
                <p>{{'sessionNotification.msj2' | translate}}</p>
            </div>
            <br>
            <div class="grid p-fluid">
                <div class="col-12">
                    <button type="button" pRipple pButton (click)="extendSession()" label="Étendre"
                        class="p-button-warning"></button>
                </div>
            </div>
        </div>
    </ng-template>
</p-toast>
<p-toast position="top-center" key="sessionError" [breakpoints]="{'350px': {width: '100%'}}" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div class="flex flex-column" style="flex: 1">
            <div class="text-center">
                <i class="pi pi-times-circle" style="font-size: 3rem"></i>
                <h4 class="text-red-900">{{'sessionNotification.ExpiredSession' | translate}}</h4>
                <p>{{'sessionNotification.ExpiredSessionMsj' | translate}}</p>
                <p>{{'sessionNotification.click' | translate}}<strong>{{'sessionNotification.close' |
                        translate}}</strong>{{'sessionNotification.redirection' | translate}}</p>
            </div>
            <br>
            <div class="grid p-fluid">
                <div class="col-12">
                    <button type="button" pRipple pButton (click)="closeSessionTimeoutWarning()"
                        label="{{'sessionNotification.close' | translate}}" class="p-button-danger"></button>
                </div>
            </div>
        </div>
    </ng-template>
</p-toast>